import { CalendarClock, Wrench } from 'lucide-react'

import { Banner } from '@/components/ui/banner'
import { MaintenanceState } from '@/models/maintenance'

interface MaintenanceBannerProps {
  state: MaintenanceState
  /** Copy to show, authored in the switch note (Waffle → Switches). */
  message: string
  onDismiss?: () => void
}

/**
 * Full-width maintenance notice for the top of the app, in two states.
 *
 * Upcoming is a calm neutral heads-up; in-progress is the stronger black tone
 * since maintenance is actively affecting the product.
 */
export function MaintenanceBanner({ state, message, onDismiss }: MaintenanceBannerProps) {
  if (state === MaintenanceState.InProgress) {
    return (
      <Banner variant="black" fullWidth icon={<Wrench />} onDismiss={onDismiss}>
        {message}
      </Banner>
    )
  }

  return (
    <Banner variant="neutral" fullWidth icon={<CalendarClock />} onDismiss={onDismiss}>
      {message}
    </Banner>
  )
}
